module.exports = "<p>\n  salt-warning-dialog works!\n</p>\n"